import * as ambassadorWixPingNotificationsV1PublicNotification from './ping-notifications-v1-public-notification-notifications.http.js';
import * as ambassadorWixPingNotificationsV1PublicNotificationTypes from './ping-notifications-v1-public-notification-notifications.types.js';
import * as ambassadorWixPingNotificationsV1PublicNotificationUniversalTypes from './ping-notifications-v1-public-notification-notifications.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function notify(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPingNotificationsV1PublicNotificationUniversalTypes.PublicNotifyRequest,
  ambassadorWixPingNotificationsV1PublicNotificationTypes.PublicNotifyRequest,
  ambassadorWixPingNotificationsV1PublicNotificationUniversalTypes.Empty,
  ambassadorWixPingNotificationsV1PublicNotificationTypes.Empty
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPingNotificationsV1PublicNotification.notify(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/notify',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Public_notification as Public_notificationOriginal,
  PublicNotifyRequest as PublicNotifyRequestOriginal,
  PublicNotifyRequestRecipientsFilterOneOf as PublicNotifyRequestRecipientsFilterOneOfOriginal,
  PublicNotifyRequestActionTargetOneOf as PublicNotifyRequestActionTargetOneOfOriginal,
  ToSiteContributors as ToSiteContributorsOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  ToContacts as ToContactsOriginal,
  ToTopicsSubscribers as ToTopicsSubscribersOriginal,
  Channel as ChannelOriginal,
  ChannelWithLiterals as ChannelWithLiteralsOriginal,
  DashboardPages as DashboardPagesOriginal,
  DashboardPagesWithLiterals as DashboardPagesWithLiteralsOriginal,
  Empty as EmptyOriginal,
} from './ping-notifications-v1-public-notification-notifications.types.js';
